export const getAllBrands = "/brand";
export const getFindWheeler = "/product/find-by-wheeler";
export const findIdByProduct = "/car";
export const findModelById = "model/find-by-id"